export default __webpack_public_path__ + "static/media/myimage.e870a640.jpg";